/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AdminPanelBillingGroupsPlansAndBillingQueryVariables = {
    orgRelayId: string;
};
export type AdminPanelBillingGroupsPlansAndBillingQueryResponse = {
    readonly org: {
        readonly id?: string | undefined;
        readonly " $fragmentRefs": FragmentRefs<"AdminPanelBillingGroupsPlansAndBilling_org">;
    } | null;
};
export type AdminPanelBillingGroupsPlansAndBillingQuery = {
    readonly response: AdminPanelBillingGroupsPlansAndBillingQueryResponse;
    readonly variables: AdminPanelBillingGroupsPlansAndBillingQueryVariables;
};



/*
query AdminPanelBillingGroupsPlansAndBillingQuery(
  $orgRelayId: ID!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      id
      ...AdminPanelBillingGroupsPlansAndBilling_org
    }
    id
  }
}

fragment AdminPanelBillingGroupsPlansAndBilling_org on Org {
  id
  primaryOrgCalendar
  ...AvatarRowNew_org
  ...SsoAdminPortalButton_org
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        ...SsoAdminPortalButton_billingGroup
        id
        name
        createdAtMillis
        invitePolicy
        type
        personListPaginatedErrorable {
          __typename
          __isOrgPersonListPaginatedErrorable: __typename
          ... on GraphEntityError {
            message
          }
          ... on OrgPersonListPaginated {
            count
          }
        }
        manualMembers {
          __typename
          ... on BillingGroupManualMemberList {
            list {
              externalUserId
              calendarId
              userId
              orgPerson {
                __typename
                ... on OrgPerson {
                  userId
                  personId
                  primaryCalendarId
                  isYou
                  signUpMillis
                  profile {
                    givenName
                    familyName
                  }
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
                ... on Node {
                  __isNode: __typename
                  id
                }
              }
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        adminOrgPersons {
          __typename
          ... on OrgPersonList {
            list {
              userId
              personId
              primaryCalendarId
              isYou
              signUpMillis
              profile {
                givenName
                familyName
              }
              id
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              type
              productType
              seatCount
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        stripeCustomerPortalSession {
          __typename
          ... on StripeCustomerPortalSession {
            sessionUrl
            account {
              accountId
              stripeCustomerId
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  currentOrgPersons {
    __typename
    ... on OrgPersonList {
      list {
        ...AvatarPerson_orgPerson
        primaryCalendarId
        userId
        personId
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        id
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_orgPerson on OrgPerson {
  __typename
  id
  primaryCalendarId
  isYou
  userId
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRowNew_org on Org {
  ...AvatarPerson_org
}

fragment SsoAdminPortalButton_billingGroup on BillingGroupErrorable {
  __isBillingGroupErrorable: __typename
  ... on BillingGroup {
    id
    type
    ssoAdminPortalLink {
      __typename
      ... on SsoAdminPortalLink {
        link
      }
      ... on GraphEntityError {
        message
        statusCode
      }
    }
  }
  ... on GraphEntityError {
    message
    statusCode
  }
}

fragment SsoAdminPortalButton_org on Org {
  id
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUpMillis",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            (v12 /*: any*/)
        ],
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v15 = {
        "kind": "InlineFragment",
        "selections": [
            (v5 /*: any*/),
            (v14 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v16 = [
        (v2 /*: any*/)
    ], v17 = {
        "kind": "InlineFragment",
        "selections": [
            (v14 /*: any*/),
            (v5 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AdminPanelBillingGroupsPlansAndBillingQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AdminPanelBillingGroupsPlansAndBilling_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AdminPanelBillingGroupsPlansAndBillingQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroups",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "BillingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "createdAtMillis",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "invitePolicy",
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personListPaginatedErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isOrgPersonListPaginatedErrorable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "count",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonListPaginated",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "manualMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "BillingGroupManualMember",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUserId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "calendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v6 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "orgPerson",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v3 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v6 /*: any*/),
                                                                                                (v7 /*: any*/),
                                                                                                (v8 /*: any*/),
                                                                                                (v9 /*: any*/),
                                                                                                (v10 /*: any*/),
                                                                                                (v13 /*: any*/)
                                                                                            ],
                                                                                            "type": "OrgPerson",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v15 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": (v16 /*: any*/),
                                                                                            "type": "Node",
                                                                                            "abstractKey": "__isNode"
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "BillingGroupManualMemberList",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "adminOrgPersons",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgPerson",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v6 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonList",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentSubscription",
                                                                            "kind": "LinkedField",
                                                                            "name": "subscription",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "productType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "seatCount",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SubscriptionDetails",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "stripeCustomerPortalSession",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "sessionUrl",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "AccountStripe",
                                                                            "kind": "LinkedField",
                                                                            "name": "account",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "accountId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "stripeCustomerId",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "StripeCustomerPortalSession",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "ssoAdminPortalLink",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "link",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "SsoAdminPortalLink",
                                                                                    "abstractKey": null
                                                                                },
                                                                                (v15 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "BillingGroup",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "type": "BillingGroupErrorable",
                                                            "abstractKey": "__isBillingGroupErrorable"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "BillingGroupList",
                                            "abstractKey": null
                                        },
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgAccountingPeriod",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DateRange",
                                                    "kind": "LinkedField",
                                                    "name": "periodRange",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "minDate",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "maxDate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaMax",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaUsed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enforcementState",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgAccountingPeriod",
                                            "abstractKey": null
                                        },
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "featureGrid",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PaymentStateMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "stateMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PrimaryBillingGroupMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "primaryBillingGroupMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": (v16 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FeatureGrid",
                                            "abstractKey": null
                                        },
                                        (v17 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "currentOrgPersons",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgPerson",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserProfile",
                                                            "kind": "LinkedField",
                                                            "name": "profile",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "externalImageUrl",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v7 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgPersonList",
                                            "abstractKey": null
                                        },
                                        (v17 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "cf674c359b4ac683358c8d2aac35cd68",
            "id": null,
            "metadata": {},
            "name": "AdminPanelBillingGroupsPlansAndBillingQuery",
            "operationKind": "query",
            "text": "query AdminPanelBillingGroupsPlansAndBillingQuery(\n  $orgRelayId: ID!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...AdminPanelBillingGroupsPlansAndBilling_org\n    }\n    id\n  }\n}\n\nfragment AdminPanelBillingGroupsPlansAndBilling_org on Org {\n  id\n  primaryOrgCalendar\n  ...AvatarRowNew_org\n  ...SsoAdminPortalButton_org\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        ...SsoAdminPortalButton_billingGroup\n        id\n        name\n        createdAtMillis\n        invitePolicy\n        type\n        personListPaginatedErrorable {\n          __typename\n          __isOrgPersonListPaginatedErrorable: __typename\n          ... on GraphEntityError {\n            message\n          }\n          ... on OrgPersonListPaginated {\n            count\n          }\n        }\n        manualMembers {\n          __typename\n          ... on BillingGroupManualMemberList {\n            list {\n              externalUserId\n              calendarId\n              userId\n              orgPerson {\n                __typename\n                ... on OrgPerson {\n                  userId\n                  personId\n                  primaryCalendarId\n                  isYou\n                  signUpMillis\n                  profile {\n                    givenName\n                    familyName\n                  }\n                }\n                ... on GraphEntityError {\n                  message\n                  statusCode\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        adminOrgPersons {\n          __typename\n          ... on OrgPersonList {\n            list {\n              userId\n              personId\n              primaryCalendarId\n              isYou\n              signUpMillis\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              type\n              productType\n              seatCount\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        stripeCustomerPortalSession {\n          __typename\n          ... on StripeCustomerPortalSession {\n            sessionUrl\n            account {\n              accountId\n              stripeCustomerId\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  currentOrgPersons {\n    __typename\n    ... on OrgPersonList {\n      list {\n        ...AvatarPerson_orgPerson\n        primaryCalendarId\n        userId\n        personId\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        id\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_orgPerson on OrgPerson {\n  __typename\n  id\n  primaryCalendarId\n  isYou\n  userId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRowNew_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment SsoAdminPortalButton_billingGroup on BillingGroupErrorable {\n  __isBillingGroupErrorable: __typename\n  ... on BillingGroup {\n    id\n    type\n    ssoAdminPortalLink {\n      __typename\n      ... on SsoAdminPortalLink {\n        link\n      }\n      ... on GraphEntityError {\n        message\n        statusCode\n      }\n    }\n  }\n  ... on GraphEntityError {\n    message\n    statusCode\n  }\n}\n\nfragment SsoAdminPortalButton_org on Org {\n  id\n}\n"
        }
    } as any;
})();
(node as any).hash = '992378ff861a31e07910535b94e74f9c';
export default node;
